import { debounce } from "lodash-es"
import { trafficStarsBottomPc } from "./templates"
import "./traffic-stars-styles.css"
import { isMobile } from "@modules/util/device"

export const trafficStarsOnWindowResizeDebounceMs = 200

export function rerenderTrafficStarsPcBottom() {
    if (userData.hasAdFree || !userData.isAgeVerified) {
        return
    }

    const pcTrafficStars = document.querySelector("#traffic-stars-bottom")
    if (pcTrafficStars) {
        pcTrafficStars.outerHTML = trafficStarsBottomPc
    }
}

if (!userData.hasAdFree && userData.isAgeVerified) {
    window.addEventListener(
        "orientationchange",
        debounce(rerenderTrafficStarsPcBottom, trafficStarsOnWindowResizeDebounceMs),
    )
    // DONT initiate an event listener on resize to rerender solads or trafficStars on mobile
    // It will trigger on mobile when scrolling and the browser bar shows/hides. Which triggers a lot of rerenders while scrolling
    // alternative fix would be to check for width changes only.
    if (!isMobile()) {
        window.addEventListener("resize", debounce(rerenderTrafficStarsPcBottom, trafficStarsOnWindowResizeDebounceMs))
    }
}
